// extracted by mini-css-extract-plugin
export default {"tooltip":"uT-z","arrow":"vT-z"};